import React from 'react';
import Icon from '../atoms/Icon';

function ReportCardIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 32 27">
      <g fill='currentColor' fillRule='evenodd'>
        <path d="M32 0V26.6673H0V0H32ZM2.66592 24.0004H29.3341V2.66592H2.66592V24.0004Z"/>
        <path d="M16.0003 8.0002V10.6661H5.33307V8.0002H16.0003Z"/>
        <path d="M27.6094 7.60908L22.6669 12.5524L19.0575 8.94294L20.9428 7.05674L22.6669 8.7809L25.7241 5.72378L27.6094 7.60908Z"/>
        <path d="M16.0003 16.0004V18.6663H5.33307V16.0004H16.0003Z"/>
        <path d="M27.6094 15.6093L22.6669 20.5526L19.0575 16.9431L20.9428 15.0569L22.6669 16.7811L25.7241 13.724L27.6094 15.6093Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(ReportCardIcon);
